<template>
  <div class="page-shell page-shell--deliver-warning">
    <section class="page-shell__content">
      <div class="page-shell__panel page-shell__tabs">
        <el-tabs v-model="activeName" @tab-click="handleClick" class="customTabs" type="border-card">
          <el-tab-pane label="未处理" name="waiting">
            <div class="page-shell__tab-pane">
              <public-table
                :loading="messageLoading"
                :column="column"
                :tableData="messages"
                :PageInfo="listQuery"
                @handlePaginationChange="getMessageList"
              >
                <template v-slot:atWhen="{ row }">
                  {{ row.atWhen ? timetrans(row.atWhen) : "-" }}
                </template>
                <template v-slot:status="{ row }">
                  {{ showMessageStatus(row.status) }}
                </template>
                <template v-slot:operation="{ row }">
                  <el-button
                    size="mini"
                    type="text"
                    v-permit="'Market.MarketWarningNotify.Update'"
                    v-if="row.handleStatus == 'waiting'"
                    @click="handleMessage(row)"
                  >
                    处理
                  </el-button>
                  <el-button
                    size="mini"
                    type="text"
                    v-if="row.resourceType"
                    @click="handleJump(row)"
                  >
                    关联资源详情
                  </el-button>
                </template>
              </public-table>
            </div>
          </el-tab-pane>
          <el-tab-pane label="已处理" name="finished">
            <div class="page-shell__tab-pane">
              <public-table
                :loading="messageLoading"
                :column="columnf"
                :tableData="messages"
                :PageInfo="listQuery"
                @handlePaginationChange="getMessageList"
              >
                <template v-slot:atWhen="{ row }">
                  {{ row.atWhen ? timetrans(row.atWhen) : "-" }}
                </template>
                <template v-slot:handleTime="{ row }">
                  {{ row.handleTime ? timetrans(row.handleTime) : "-" }}
                </template>
                <template v-slot:operation="{ row }">
                  <el-button
                    size="mini"
                    type="text"
                    v-if="row.resourceType"
                    @click="handleJump(row)"
                  >
                    关联资源详情
                  </el-button>
                </template>
              </public-table>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </section>
    <handle-message
      :marketID="marketID"
      :messageID="handleMessageID"
      :dialogVisible="showHandleMessage"
      :onSuccess="handleMessageSuccess"
      :onClose="() => (showHandleMessage = false)"
    >
    </handle-message>
  </div>
</template>
<script>
const defaultListQuery = {
  page: 1,
  pageSize: 10
};
import { timetrans } from '@/utils/validate';
import { showMessageStatus } from '@/utils/dictionary';
import { fetMarketMessage } from '@/api/message';
import { errorHandle } from '@/utils/error';
import HandleMessage from './components/handleMessage';
export default {
  name: 'WarningInfo',
  components: {
    'handle-message': HandleMessage
  },
  data() {
    return {
      showMessageStatus,
      timetrans,
      activeName: 'waiting',
      listQuery: defaultListQuery,
      messageLoading: false,
      messages: [],
      showHandleMessage: false,
      handleMessageID: '',
      total: 1,
      columnf: [
        {
          prop: 'messageType',
          label: '消息类型',
          width: '184px'
        },
        {
          label: '消息',
          prop: 'messageContent'
        },
        {
          prop: 'atWhen',
          label: '发生时间',
          width: '184px',
          scopeStatus: true
        },
        {
          prop: 'handleUserName',
          minWidth: '80px',
          label: '处理人'
        },
        {
          prop: 'handleTime',
          label: '处理时间',
          width: '184px',
          scopeStatus: true
        },
        {
          prop: 'note',
          label: '备注'
        },
        {
          prop: 'operation',
          label: '操作',
          width: '148px',
          scopeStatus: true
        }
      ],
      column: [
        {
          prop: 'messageType',
          label: '消息类型',
          width: '184px'
        },
        {
          label: '消息',
          prop: 'messageContent'
        },
        {
          prop: 'atWhen',
          label: '发生时间',
          width: '184px',
          scopeStatus: true
        },
        {
          prop: 'status',
          label: '状态',
          width: '184px',
          scopeStatus: true
        },
        {
          prop: 'operation',
          label: '操作',
          width: '148px',
          scopeStatus: true
        }
      ]
    };
  },
  created() {
    this.getMessageList();
  },
  filters: {
    filterDeliverableType(type) {
      return type && type === 'saas' ? 'SaaS' : type === 'paas' ? 'PaaS' : '';
    }
  },

  computed: {
    open_market() {
      return this.$store.state.enterprise.enterpriseInfo.open_market;
    },
    marketID() {
      return this.$store.state.enterprise.enterpriseInfo.marketID;
    }
  },
  methods: {
    handleJump(row) {
      let name = 'storeOrderDetails';
      const obj = {
        orderID: row.resourceID,
        marketID: row.marketID,
        deliverID: row.resourceID
      };

      if (row.resourceType === 'deliveryApp') {
        name = 'deliverDetails';
      }
      this.$router.push({
        name,
        params: obj
      });
    },
    getMessageList(params) {
      this.messageLoading = true;
      this.listQuery.marketID = this.marketID;
      this.listQuery.status = this.activeName;
      if (params) {
        this.listQuery = { ...this.listQuery, ...params };
      }
      fetMarketMessage(this.listQuery)
        .then((re) => {
          this.messages = re.messages;
          this.listQuery.total = re.total;
          this.messageLoading = false;
        })
        .catch((err) => {
          this.messageLoading = false;
          errorHandle(err);
        });
    },
    handleClick(tab, event) {
      this.activeName = tab.name;
      this.listQuery.page = 1;
      this.getMessageList();
    },
    handleMessage(row) {
      this.showHandleMessage = true;
      this.handleMessageID = row.messageID;
    },
    handleMessageSuccess() {
      this.showHandleMessage = false;
      this.$message.success('处理异常信息成功');
      this.getMessageList();
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import 'src/styles/page-shell.scss';
</style>



// WEBPACK FOOTER //
// src/views/deliverManage/warninginfo/index.vue